import {
  joinPath,
  useOverlayHostPathname,
} from "shared-ui/src/hooks/routedOverlays";
import { stripGlobalDialogSegment } from "@features/ecommerce/constants/cartRouteSegments";
import { stripEmailOrderInvoicesDialog } from "@features/orders-features/components/emailOrderInvoicesRouteSegments";

/**
 * The page path that page-scoped settings (grid state, saved views, widget filters) are keyed
 * by. Strips open routed drawers and routed dialogs such as `email-order-invoices/:orderKey`
 * or `buy-again-result`, so opening one does not switch keys and reset the grid.
 */
export const useSettingsHostPathname = (): string => {
  const hostPathname = useOverlayHostPathname();
  const stripped = stripGlobalDialogSegment(
    stripEmailOrderInvoicesDialog(hostPathname),
  );
  return stripped === hostPathname.replace(/\/+$/, "")
    ? hostPathname
    : joinPath(stripped);
};
